var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('heading-one',{staticClass:"-margin-md _mb-0",attrs:{"id":"cmstitle"}},[_vm._v("\n    "+_vm._s(_vm.title)+"\n  ")]),_vm._v(" "),_c('p',{staticClass:"date -textright -margin-md",attrs:{"id":"cmsupdateat"}},[_vm._v("\n    "+_vm._s(_vm.updateAt)+"\n  ")]),_vm._v(" "),_c('div',{attrs:{"id":"cmscontens"}},[_vm._t("default")],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-01c6b70d","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/cms/CmsWrapperTemplate.vue
// module id = null
// module chunks = 